var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArpWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.1 20.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.4,12.5h-3.6l2.5,2.5-3.3,3.3-2.5-2.5v3.6h-4.8v-3.5l-2.6,2.6-3.4-3.5,2.5-2.5H.6v-4.9h3.5l-2.6-2.6,3.4-3.4,2.7,2.7V.6h4.9v3.7l2.6-2.5,3.2,3.3-2.6,2.6h3.6v4.8h0ZM15.4,10.1c0-1.6-.5-2.9-1.4-3.9-1-1-2.2-1.4-3.9-1.4s-2.9.5-3.9,1.5-1.5,2.3-1.5,3.9.5,3,1.4,3.9c1,.9,2.3,1.4,3.9,1.4s2.9-.5,3.9-1.5,1.5-2.3,1.5-3.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArpWhite);
export default __webpack_public_path__ + "static/media/arp-white.043bf1abca0ab4e0deefc88b7294bdb7.svg";
export { ForwardRef as ReactComponent };